<template>
  <b-card class="shadow-sm h-100">
    <b-card-title class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <feather-icon
          icon="ActivityIcon"
          size="18"
          class="mr-2 text-muted"
        />
        Atividades Recentes
      </div>
      <b-button
        variant="flat-link"
        size="sm"
        class="text-muted"
        @click="$emit('viewAll')"
      >
        Ver todas
        <feather-icon
          icon="ArrowRightIcon"
          size="14"
          class="ml-1"
        />
      </b-button>
    </b-card-title>

    <div class="recent-activities">
      <div
        v-for="activity in recentActivities"
        :key="activity.id"
        class="d-flex align-items-start p-2 rounded mb-1"
        style="background: #f8f9fa"
      >
        <div
          class="rounded-circle d-flex align-items-center justify-content-center mr-3 mt-1"
          :class="activity.iconBg"
          style="width: 32px; height: 32px; min-width: 32px"
        >
          <feather-icon
            :icon="activity.icon"
            size="14"
            :class="activity.iconColor"
          />
        </div>
        <div class="flex-grow-1 min-width-0">
          <small class="font-weight-bold d-block text-truncate">
            {{ activity.title }}
          </small>
          <small class="text-muted d-block text-truncate">
            {{ activity.description }}
          </small>
        </div>
        <div class="text-right ml-2 shrink-0">
          <small class="text-muted d-block">
            {{ activity.time }}
          </small>
          <b-badge
            v-if="activity.badge"
            :variant="activity.badgeVariant"
            class="mt-1"
            size="sm"
          >
            {{ activity.badge }}
          </b-badge>
        </div>
      </div>

      <div
        v-if="!recentActivities.length"
        class="text-center text-muted py-4"
      >
        Nenhuma atividade recente
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BButton,
  BBadge,
} from 'bootstrap-vue'
import agendamentosService from '@/services/agendamentos'
import { getStatusLabel, getStatusBadgeClass, getMotivoLabel } from '../calendar-utils'

const badgeVariantMap = {
  'badge-info': 'info',
  'badge-warning': 'warning',
  'badge-success': 'success',
  'badge-danger': 'danger',
  'badge-secondary': 'secondary',
}

const statusIconMap = {
  AGENDADO: { icon: 'CalendarIcon', iconBg: 'bg-light-info', iconColor: 'text-info' },
  PENDENTE: { icon: 'ClockIcon', iconBg: 'bg-light-warning', iconColor: 'text-warning' },
  EM_ANDAMENTO: { icon: 'ActivityIcon', iconBg: 'bg-light-info', iconColor: 'text-info' },
  CONCLUIDO: { icon: 'CheckCircleIcon', iconBg: 'bg-light-success', iconColor: 'text-success' },
  REAGENDADO: { icon: 'RefreshCwIcon', iconBg: 'bg-light-warning', iconColor: 'text-warning' },
}

export default {
  components: {
    BCard,
    BCardTitle,
    BButton,
    BBadge,
  },
  data() {
    return {
      atividades: [],
    }
  },
  computed: {
    recentActivities() {
      if (!this.atividades.length) return []

      return this.atividades.map(item => {
        const statusKey = (item.status || '').toUpperCase()
        const statusLabel = getStatusLabel(statusKey)
        const statusBadge = getStatusBadgeClass(statusKey)
        const iconConfig = statusIconMap[statusKey] || statusIconMap.AGENDADO
        const clienteName = item.cliente?.nome || 'Cliente'
        const isStatusChange = item.acao === 'status_alterado'
        const motivoLabel = item.motivo ? getMotivoLabel(item.motivo) : null

        return {
          id: item.id,
          title: isStatusChange ? `Status alterado: ${clienteName}` : clienteName,
          description: motivoLabel || item.observacoes || `${item.tipo} - ${clienteName}`,
          time: this.formatTimeAgo(item.created_at),
          icon: iconConfig.icon,
          iconBg: iconConfig.iconBg,
          iconColor: iconConfig.iconColor,
          badge: statusLabel,
          badgeVariant: badgeVariantMap[statusBadge] || 'secondary',
        }
      })
    },
  },
  async created() {
    await this.carregarAtividades()
  },
  methods: {
    async carregarAtividades() {
      try {
        const atendenteId = localStorage.getItem('executivo_id')
        const params = { limit: 5 }
        if (atendenteId) params.atendente_id = atendenteId
        const response = await agendamentosService.buscarAtividadesRecentes(params)
        this.atividades = response?.data || response || []
      } catch (error) {
        // console.error('Erro ao carregar atividades recentes:', error)
      }
    },
    formatTimeAgo(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const now = new Date()
      const diffMs = now.getTime() - date.getTime()
      const diffMins = Math.floor(diffMs / 60000)
      const diffHours = Math.floor(diffMins / 60)

      if (diffMins < 1) return 'agora'
      if (diffMins < 60) return `há ${diffMins} min`
      if (diffHours < 24) return `há ${diffHours}h`
      return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
    },
  },
}
</script>
